<template>
  <div class="back-in-stock-signup"
    data-ssn-part="notification-option" data-ssn-type="bis"
    :class="{ 'is-subscribed': hasCurrentSubscription ? true : false, 'is-unsubscribing': isUnsubscribing }">
    <label class="ssn-checkbox-row">
      <input :checked="modelValue" type="checkbox" class="ssn-checkbox-row__input" data-ssn-part="checkbox-input"
        @change="onCheckboxChange" />
      <span class="ssn-checkbox-row__content">
        <span class="smart-stock-notification-checkbox-label" data-ssn-part="checkbox-label">{{ localizations.whenBackInStock }}</span>
        <span v-if="hasCurrentSubscription"
          data-ssn-part="subscription-state"
          class="current-subscription-text xxxsmart-stock-notification-checkbox-label">({{
            subscribedText }})</span>
      </span>
    </label>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';

const andale = window.andalePluginsStockNotificationsPublic || {
  localizations: {},
};

export default {
  name: 'BackInStockSignup',
  props: {
    productId: { type: Number, required: true },
    modelValue: { type: Boolean, default: false },
    uuid: { type: String, default: null }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const deleting = ref(false);
    // const uuid = ref(null);
    // const isSubscribed = ref(false);
    const modelValueProxy = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    });
    const localizations = ref({
      whenBackInStock: andale.localizations.whenBackInStock || '',
      youAreSignedUp: andale.localizations.youAreSignedUp || '',
      youWillBeUnsubscribed: andale.localizations.youWillBeUnsubscribed || ''
    });
    const hasCurrentSubscription = computed(() => {
      return props.uuid ? true : false;
    });
    const isChecked = computed(() => props.modelValue ? true : false);
    const isUnsubscribing = computed(() => {
      return hasCurrentSubscription.value && !isChecked.value;
    });
    const subscribedText = computed(() => {
      return isUnsubscribing.value ? localizations.value.youWillBeUnsubscribed : localizations.value.youAreSignedUp;
    });

    const onCheckboxChange = (event) => {
      emit('update:modelValue', event.target.checked);
    };

    onMounted(() => {
    });

    return {
      deleting,
      isChecked,
      hasCurrentSubscription,
      isUnsubscribing,
      localizations,
      subscribedText,
      // unsubscribe,
      onCheckboxChange
    };
  }
};
</script>

<style scoped>
.back-in-stock-signup.is-subscribed {
  background-color: var(--ssn-option-active-background, #d4edda);
  color: var(--ssn-option-active-color, #155724);
  border-radius: 6px;
  font-size: 0.95rem;
}

.ssn-checkbox-row {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  cursor: pointer;
}

.ssn-checkbox-row__input {
  margin: 0;
}

.ssn-checkbox-row__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  min-width: 0;
}

.is-unsubscribing span.smart-stock-notification-checkbox-label {
  text-decoration: line-through;
}

.current-subscription-text {
  color: var(--ssn-help-text-color, #b1abab);
  font-size: 0.92em;
  font-style: italic;
  font-weight: 400;
  margin-left: 0;
  line-height: 1.25;
}

.back-in-stock-signup {
  padding-left: 0.5rem;
}

.subscription-status {
  margin-top: 0.5rem;
  padding-left: 1.5rem;
}
</style>
